import * as _ from "lodash";
import { FormEvent } from 'react';
import { IDonorProfileAddress, IDonorProfileAddressLookupData } from '@nkr/models/index';
import { Col, ControlLabel, Form, FormControl, FormGroup, Row } from 'react-bootstrap';
import { updateDonorAddress } from './update-donor-address'
import { IValidation } from './validation';

interface IProps {
    data: IDonorProfileAddress,
    lookupData: IDonorProfileAddressLookupData,
    validation: IValidation,
    dirty: boolean,
    onChange: (data: IDonorProfileAddress) => void
}

const PersonalInformation = (props: IProps) => {
    if (props.data == null || props.lookupData == null) {
        return null
    }

    const { fullName, country, addressLine1, addressLine2, city, state, postalCode, phone, phone2, email } = props.data;
    const { countryList, stateList } = props.lookupData;

    const handleSelectChange = (e: FormEvent<FormControl & HTMLSelectElement>) => {
        let name = e.currentTarget.name;
        let value = parseInt(e.currentTarget.value);
        let data = _.cloneDeep(props.data);

        data = updateDonorAddress.onNumericChange(name, value, data);

        props.onChange(data);
    };

    const handleTextChange = (e: FormEvent<FormControl & HTMLInputElement>) => {
        let name = e.currentTarget.name;
        let value = e.currentTarget.value;

        // if (name == 'phone' || name == 'phone2') {
        //     let regex = new RegExp('^[0-9\-]*$');

        //     if (!regex.test(value)) {
        //         return;
        //     }
        // }

        let data = _.cloneDeep(props.data);

        data = updateDonorAddress.onTextChange(name, value, data);

        props.onChange(data);
    };

    return (
        <div className='container-fluid donor-profile-section donor-profile-content'>
            <Row>
                <Col xs={12} lg={6}>
                    <Form horizontal>
                        <FormGroup validationState={props.dirty && props.validation.fullName == false ? 'error' : null}>
                            <Col xs={12} lg={4} componentClass={ControlLabel}>Full Name:</Col>
                            <Col xs={12} lg={8}>
                                <FormControl name='fullName' maxLength={50} value={fullName} onChange={handleTextChange} />
                            </Col>
                        </FormGroup>

                        <FormGroup>
                            <Col xs={12} lg={4} componentClass={ControlLabel}>Country:</Col>
                            <Col xs={12} lg={8}>
                                <FormControl
                                    componentClass='select'
                                    name='country'
                                    value={country}
                                    onChange={handleSelectChange}
                                >
                                    {countryList.map(country =>
                                        <option key={'country-' + country.id} value={country.id}>{country.description}</option>
                                    )}
                                </FormControl>
                            </Col>
                        </FormGroup>

                        <FormGroup validationState={props.dirty && props.validation.addressLine1 == false ? 'error' : null}>
                            <Col xs={12} lg={4} componentClass={ControlLabel}>Address Line 1:</Col>
                            <Col xs={12} lg={8}>
                                <FormControl name='addressLine1' maxLength={50} value={addressLine1} onChange={handleTextChange} />
                            </Col>
                        </FormGroup>

                        <FormGroup>
                            <Col xs={12} lg={4} componentClass={ControlLabel}>Address Line 2:</Col>
                            <Col xs={12} lg={8}>
                                <FormControl name='addressLine2' maxLength={50} value={addressLine2} onChange={handleTextChange} />
                            </Col>
                        </FormGroup>

                        <FormGroup validationState={props.dirty && props.validation.city == false ? 'error' : null}>
                            <Col xs={12} lg={4} componentClass={ControlLabel}>City:</Col>
                            <Col xs={12} lg={8}>
                                <FormControl name='city' maxLength={50} value={city} onChange={handleTextChange} />
                            </Col>
                        </FormGroup>

                        <FormGroup validationState={props.dirty && props.validation.state == false ? 'error' : null}>
                            <Col xs={12} lg={4} componentClass={ControlLabel}>State:</Col>
                            <Col xs={12} lg={8}>
                                <FormControl
                                    componentClass='select'
                                    name='state'
                                    value={state}
                                    onChange={handleTextChange}
                                >
                                    <option value={0}>- Select -</option>
                                    {stateList.map(state =>
                                        <option key={'state-' + state.id} value={state.abbreviation}>{state.description}</option>
                                    )}
                                </FormControl>
                            </Col>
                        </FormGroup>

                        <FormGroup validationState={props.dirty && props.validation.postalCode == false ? 'error' : null}>
                            <Col xs={12} lg={4} componentClass={ControlLabel}>Postal Code:</Col>
                            <Col xs={12} lg={8}>
                                <FormControl name='postalCode' maxLength={10} value={postalCode} onChange={handleTextChange} />
                            </Col>
                        </FormGroup>

                        <FormGroup validationState={props.dirty && props.validation.phone == false ? 'error' : null}>
                            <Col xs={12} lg={4} componentClass={ControlLabel}>Phone #:</Col>
                            <Col xs={12} lg={8}>
                                <FormControl name='phone' maxLength={20} value={phone} onChange={handleTextChange} />
                            </Col>
                        </FormGroup>

                        <FormGroup validationState={props.dirty && props.validation.phone2 == false ? 'error' : null}>
                            <Col xs={12} lg={4} componentClass={ControlLabel}>Secondary Phone #:</Col>
                            <Col xs={12} lg={8}>
                                <FormControl name='phone2' maxLength={20} value={phone2} onChange={handleTextChange} />
                            </Col>
                        </FormGroup>

                        <FormGroup validationState={props.dirty && props.validation.email == false ? 'error' : null}>
                            <Col xs={12} lg={4} componentClass={ControlLabel}>Email Address:</Col>
                            <Col xs={12} lg={8}>
                                <FormControl name='email' maxLength={50} value={email} onChange={handleTextChange} />
                            </Col>
                        </FormGroup>
                    </Form>
                </Col>
            </Row>
        </div>
    );
}

export default PersonalInformation;